// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const BASE_URL = "https://ecom.cyberathon.com";
// const API_URL = BASE_URL + "/index.php/Api/get_hijama_banners_list";

// function HomeBanners() {
//   const [banners, setBanners] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // FETCH DATA FROM PHP BACKEND
//   useEffect(() => {
//     const fetchBannerData = async () => {
//       try {
//         const response = await axios.get(API_URL);
//         setBanners(response.data.data || []);
//       } catch (error) {
//         console.error("Error fetching banners:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBannerData();
//   }, []);

//   if (loading) return <p className="text-center py-5">Loading banners...</p>;

//   if (!banners.length)
//     return <p className="text-center py-5 text-danger">No banners found</p>;

//   return (
//     <div className="container-fluid px-0">
//       <div className="row g-0">
//         <div className="col-12">

//           <div
//           key={banners.length}
//             id="carouselDynamic"
//             className="carousel slide carousel-fade"
//             data-bs-ride="carousel"
//             data-bs-interval="2000"
//           >
//             {/* SLIDES */}
//             <div className="carousel-inner">

//               {banners.map((item, index) => (
//                 <div
//                   key={index}
//                   className={`carousel-item ${index === 0 ? "active" : ""}`}
//                   data-bs-interval="3000"
//                   style={{
//                     backgroundImage: `url(${BASE_URL}/${item.banner})`,
//                     backgroundSize: "cover",
//                     backgroundPosition: "center",
//                     height: "66vh",
//                   }}
//                 >
//                   <div className="carousel-caption d-block h-100 d-flex align-items-center">
//                     <div className="container">
//                       {/* yaha agar koi heading/text dalna ho to add kar sakte ho */}
//                     </div>
//                   </div>
//                 </div>
//               ))}

//             </div>

//             {/* PREV BUTTON */}
//             <button
//               className="carousel-control-prev d-flex justify-content-start ms-2"
//               type="button"
//               data-bs-target="#carouselDynamic"
//               data-bs-slide="prev"
//             >
//               <i className="bi bi-chevron-left viewAll viewAll1"></i>
//             </button>

//             {/* NEXT BUTTON */}
//             <button
//               className="carousel-control-next d-flex justify-content-end me-2"
//               type="button"
//               data-bs-target="#carouselDynamic"
//               data-bs-slide="next"
//             >
//               <i className="bi bi-chevron-right viewAll viewAll1"></i>
//             </button>

//           </div>

//         </div>
//       </div>
//     </div>
//   );
// }

// export default HomeBanners;




import React, { useEffect, useState } from "react";
import axios from "axios";
import { Carousel } from "bootstrap";

const BASE_URL = "https://ecom.cyberathon.com";
const API_URL = BASE_URL + "/index.php/Api/get_hijama_banners_list";

function HomeBanners() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  // FETCH DATA
  useEffect(() => {
    const fetchBannerData = async () => {
      try {
        const response = await axios.get(API_URL);
        setBanners(response.data.data || []);
      } catch (error) {
        console.error("Error fetching banners:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBannerData();
  }, []);

  // 🔥 MANUAL BOOTSTRAP INIT
  useEffect(() => {
    if (banners.length) {
      const el = document.querySelector("#carouselDynamic");
      if (el) {
        new Carousel(el, {
          interval: 3000,
          ride: "carousel",
          pause: false,
        });
      }
    }
  }, [banners]);

  if (loading) return <p className="text-center py-5">Loading banners...</p>;
  if (!banners.length)
    return <p className="text-center py-5 text-danger">No banners found</p>;

  return (
    <div className="container-fluid px-0">
      <div className="row g-0">
        <div className="col-12 ">

          <div
            id="carouselDynamic"
            className="carousel slide carousel-fade"
          >
            {/* SLIDES */}
            <div className="carousel-inner">
              {banners.map((item, index) => (
                <div
                  key={index}
                  className={`carousel-item ${index === 0 ? "active" : ""}`}
                >
                  <img
                    src={`${BASE_URL}/${item.banner}`}
                    className="d-block w-100 banner-imgsize "
                    // style={{ height: "66vh", objectFit: "cover" }}
                    alt="banner"
                  />
                </div>
              ))}
            </div>

            {/* ⬅️ PREV BUTTON (SAME AS YOURS) */}
            <button
              className="carousel-control-prev d-flex justify-content-start ms-2"
              type="button"
              data-bs-target="#carouselDynamic"
              data-bs-slide="prev"
            >
              <i className="bi bi-chevron-left viewAll viewAll1"></i>
            </button>

            {/* ➡️ NEXT BUTTON (SAME AS YOURS) */}
            <button
              className="carousel-control-next d-flex justify-content-end me-2"
              type="button"
              data-bs-target="#carouselDynamic"
              data-bs-slide="next"
            >
              <i className="bi bi-chevron-right viewAll viewAll1"></i>
            </button>

          </div>

        </div>
      </div>
    </div>
  );
}

export default HomeBanners;
 